import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Axios from "axios";
import Localizer from "@Scripts/Common/Localizer";

@Component({ name: "MagazineList" })
export default class MagazineList extends Vue {
    public localizer: any = Localizer;
    public listMagazineNews: any[] = [];
    public categories: any[] = [];
    public filterData: any = { category: null };
    public footerPages: any[] = [];
    public pageIndex: number = 0;
    public pageCount: number = 0;
    public paginatorIndex: number = 0;
    public paginatorCount: number = 0;
    public isRendered: boolean = false;
    public isLoading: boolean = false;

    get routes() {
        return (<any>window).App.routes;
    }

    @Prop() readonly category: string;

    public async created() {
        this.filterData.category = this.category;

        await this.getListData();
    }

    public async getListData() {
        this.isLoading = true;

        try {
            const result = (await Axios.post(this.routes.Magazine_MagazineNewsGetListData, this.filterData)).data;

            this.listMagazineNews = result.news;
            this.categories = result.categories;
            this.pageIndex = result.pageIndex;
            this.pageCount = result.pageCount;

            if (this.filterData.category) {
                window.history.pushState({}, "", this.routes.Magazine_MagazineNewsList + "?category=" + this.filterData.category);
            } else {
                window.history.pushState({}, "", this.routes.Magazine_MagazineNewsList);
            }

            this.pagination();
        } catch (error) { }

        this.isLoading = false;
    }

    public async setCategory(category: string) {
        this.filterData.category = category;
        this.filterData.page = 0;
        await this.setSearch();
    }

    public async setSearch() {
        await this.getListData();
    }

    public async goToPage(index: number) {
        this.filterData.page = index;
        await this.setSearch();
    }

    public async goToPrevPage() {
        if (this.pageIndex < 1) {
            return;
        }
        this.filterData.page = this.pageIndex - 1;
        await this.setSearch();
    }

    public async goToNextPage() {
        if (this.pageIndex >= this.pageCount - 1) {
            return;
        }
        this.filterData.page = this.pageIndex + 1;
        await this.setSearch();
    }

    public pagination() {
        this.paginatorCount = Math.ceil(this.pageCount / 4);
        this.paginatorIndex = Math.trunc(this.pageIndex / 4);

        this.footerPages = [...Array(this.pageCount).keys()].slice(this.paginatorIndex * 4, (this.paginatorIndex + 1) * 4);
    }

    public replaceTitle(title: string): string {
        return title.replace("|", " ");
    }

    public goToPageSelector(type: string) {
        if (type === "plus") {
            this.goToPage(this.footerPages.slice(-1)[0] + 1);
        }

        if (type === "less") {
            this.goToPage(this.footerPages.slice(0)[0] - 1);
        }
    }
}